module.exports = "/_next/static/images/59a2142508e49309280839ad1b006b74-hick@2x.png";